module.exports = __webpack_public_path__ + "img/electric_use.317ebf12.svg";